import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import { unskipShipment } from 'redux/clubSubscriptionShipments/actions';

class UnskipPackage extends Component {
  handleSubmit = () => {
    const { props } = this;
    const successFunction = () => {
      props.onCloseModal();
    };
    props.unskipShipment(props.clubSubscriptionShipmentId, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { onCloseModal } = this.props;
    return (
      <Modal title="Unskip This Shipment" onCloseModal={onCloseModal}>
        <p>Would you like to no longer skip this shipment?</p>
        <div className="c7-form__button-row">
          <a onClick={this.handleClose} className="c7-button-alt">
            Cancel
          </a>
          <button
            type="button"
            onClick={this.handleSubmit}
            className="c7-button"
          >
            Unskip this shipment
          </button>
        </div>
      </Modal>
    );
  }
}

export default connect(null, {
  unskipShipment
})(UnskipPackage);
